export default "__VITE_ASSET__DYHmffQi__"